export const LOGICAL = 'logical';
export const PLAIN = 'plain';
export const CHOICE = 'choice';
export const DATETIME = 'datetime';
export const LOCATION = 'location';
